export default "__VITE_ASSET__yz9UnQMa__"